'use strict'

/* -----------------------------------------------------------------------------
 * dependencies
 * -------------------------------------------------------------------------- */

// 3rd party
import React from 'react'
import Popper, { PopperProps } from '@mui/material/Popper'

/* -----------------------------------------------------------------------------
 * MemberInfoPopper
 *
 * The member info menus and the follow up date picker hang 10px under the left
 * edge of the button that opens them, where react-tether placed them. Popper
 * also flips one above its button when it would not fit below.
 * -------------------------------------------------------------------------- */

const modifiers = [{ name: 'offset', options: { offset: [0, 10] } }]

const MemberInfoPopper = (props: PopperProps) => (
  <Popper placement='bottom-start' modifiers={modifiers} {...props} />
)

export default MemberInfoPopper
